import React from "react";
import "reactjs-popup/dist/index.css";
import { Card, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "./CustomCards.scss";
import "../../dashboard/CloudDiscovery/CloudConfiguration.scss";
const CustomCards = ({
  cardData,
  col,
  onCardClick,
  truncateText = false,
  showLogoContainer = true,
  showFullTextOnHover = false,
}) => {
  const isDarkColor = (color) => {
    if (!color) return false;
    const darkColors = ["#000000", "#323232", "black"];
    return darkColors.includes(color.toLowerCase().trim());
  };
  const navigate = useNavigate();
  const getFullTextHoverTitle = (value) =>
    showFullTextOnHover ? value : undefined;

  return (
    <>
      <Row>
        {cardData.map((item, index) => (
          <Col
            className={col ? "mb-4" : "custom-col mb-4"}
            xs={12}
            sm={6}
            md={6}
            xl={col}
            lg={3}
            key={index}
          >
            <Card
              onClick={() => onCardClick ? onCardClick(item) : navigate(item.link)}
              className={`pt-3 cursor_pointer hover-card ${truncateText ? "truncated-card" : ""}`}
            >
              {showLogoContainer&& (
                <div className="d-flex justify-content-between align-items-start mb-2 mr-2 logo-container">
                  {item.logoComponent ? (
                    <div 
                      className={`ms-3 logo-icon-wrapper ${isDarkColor(item.color) ? "is-dark-logo" : ""}`} 
                      style={{ color: item.color }}
                    >
                      {item.logoComponent}
                    </div>
                  ) : item.imageURL && (
                    <LazyLoadImage
                      src={item.imageURL}
                      alt={item.title}
                      height={40}
                      max-width={60}
                      effect="blur"
                      className="ms-3 rounded-start"
                    />
                  )}
                  {(item.beta || item.commingsoon) && (
                    <div className="ms-5">
                      {item.beta && (
                        <span className="cloud-discovery-beta-tag me-2">
                          Beta
                        </span>
                      )}
                      {item.commingsoon && (
                        <span className="cloud-discovery-coming-soon-tag me-2">Coming Soon</span>
                      )}
                    </div>
                  )}
                </div>
              )}
              <Card.Body
                className={`ff-pam ${truncateText ? "custom-card-truncate-text" : ""}`}
              >
                {item.imageComponent && (
                  <div
                    className="icon-cards-circle"
                    style={{ backgroundColor: item.color }}
                  >
                    {item.imageComponent}
                  </div>
                )}
                <Card.Title
                  className={`fs-14px ${truncateText ? "custom-card-title-truncate" : ""}`}
                  title={getFullTextHoverTitle(item.title)}
                >
                  {item.title}
                </Card.Title>
                <Card.Text
                  className={`fs-12px ${truncateText ? "custom-card-description-truncate" : ""}`}
                  title={getFullTextHoverTitle(item.description)}
                >
                  {item.description}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </>
  );
};
export default CustomCards;
